import { useCallback } from 'react';
import { useQuery } from '@tanstack/react-query';

export function useDownloadFile(url?: string, filename?: string) {
  const getBinaryFile = useCallback(async () => {
    if (!url) return;

    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const blob = await response.blob();

    return new File([blob], filename || 'file-name', {
      type: blob.type,
    });
  }, [url, filename]);

  const {
    isLoading,
    isError,
    error,
    data: file,
  } = useQuery({
    queryKey: ['file', url],
    queryFn: getBinaryFile,
    enabled: !!url,
  });

  return { file, isLoading, isError, error };
}
